import React from "react";
import PropTypes from "prop-types";
import {
  SectionContainer,
  SectionTitle,
  SectionContent,
} from "./SectionStyles.js";

const Section = ({ title, children, style }) => {
  return (
    <SectionContainer style={style}>
      <SectionTitle>{title}</SectionTitle>
      <SectionContent>{children}</SectionContent>
    </SectionContainer>
  );
};

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  style: PropTypes.any,
};

export default Section;
